export default "__VITE_ASSET__CI0EoNJ2__"